'use strict'

export default [
  {
   name: "riskRegister",
   hideButtons: true
  },
  {
    name: "riskManagementApproach",
    fields: [
      { name: "process", height: 5 },
      { name: "tools", height: 2 },
      { name: "reporting", height:2 },
      { name: "timing", height: 2 },
      { name: "roles", height: 3 },
      { name: "tolerance", height: 2 },
      { name: "budget", height: 2 }
    ]
  }
];



// WEBPACK FOOTER //
// ./views/risk/riskManagamentApproachFormDefinition.js